import React, { PropsWithChildren } from "react"
import Button from "./Button"

type WrapperProps = {
  goBack: () => void
}

export default ({
  children: Children,
  goBack: onClick,
}: PropsWithChildren<WrapperProps>) => (
  <div className="legal-sidenav">
    <Button onClick={onClick} />
    <div className="legal-sidenav-list-item legal-sidenav-list-item--not-selected">
      {Children}
    </div>
  </div>
)
